import { LogoProps } from './types';

const Azure = ({ size = 24 }: LogoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M22.6669 5.33344V18.3201L17.3335 22.6933L9.06663 19.6802V22.6671L4.38663 16.5469L18.0265 17.6134V5.92013L22.6669 5.33344ZM18.1201 5.98688L10.4663 1.33313V4.38657L3.44032 6.45338L1.33301 9.15975V15.3069L4.34707 16.6401V8.75963L18.1201 5.98688Z"
      fill="url(#paint0_linear_1038_8147)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1038_8147"
        x1="12.0001"
        y1="22.6267"
        x2="12.0001"
        y2="1.37334"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0078D4" />
        <stop offset="0.16" stopColor="#1380DA" />
        <stop offset="0.53" stopColor="#3C91E5" />
        <stop offset="0.82" stopColor="#559CEC" />
        <stop offset="1" stopColor="#5EA0EF" />
      </linearGradient>
    </defs>
  </svg>
);

export default Azure;
